module.exports = __webpack_public_path__ + "img/banner_h5_ls.0747b062.png";